import { render } from "./SectionSolutionDAB.vue?vue&type=template&id=40177170&scoped=true"
import script from "./SectionSolutionDAB.vue?vue&type=script&lang=js"
export * from "./SectionSolutionDAB.vue?vue&type=script&lang=js"

import "./SectionSolutionDAB.vue?vue&type=style&index=0&id=40177170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40177170"]])

export default __exports__